import { toPlainTextFromRichText } from './safeHtml';

/** Whole-word #utilities, anywhere in the note, any casing. */
export const noteHasUtilitiesTag = value => /#utilities\b/i.test(toPlainTextFromRichText(value));

/** Chip the #utilities token in already-sanitized note HTML. Markup is left untouched. */
export const highlightUtilitiesTagHtml = html =>
  String(html ?? '').replace(/(<[^>]*>)|(#utilities\b)/gi, (match, tag) =>
    tag ? match : '<span class="utilities-note-tag">#utilities</span>'
  );
